<template>
  <div>
    <ModalNotification
      v-model="modalWarning"
      :title="title"
      size="xl"
    >
      <template #content-message>
        <p class="mb-4">{{ msg }}</p>
        <b-row>
          <b-col class="left-side">
            <div class="d-flex justify-content-between">
              <div class="__address">
                <div class="__address-label mb-1">{{ $t('delivery.fields.originAddress') }}</div>
                <div class="font-weight-bold">{{ address?.origin?.address || '-' }}</div>
              </div>
              <div class="align-self-start">
                <McButton variant="secondary" :text="originBtnState === BUTTON_TYPE_SAVE ? $t('global.save') : $t('delivery.provider.changePinpoint')" @click="originBtnClick" :disabled="originBtnDisabled" />
              </div>
            </div>
            <b-card body-class="ps-0 pb-0">
              <AddressGmap identifier="originAddress" :location.sync="origin" :searchInputDisabled="originInputDisabled" />
            </b-card>
          </b-col>
          <b-col class="right-side">
            <div class="d-flex justify-content-between">
              <div class="__address">
                <div class="__address-label mb-1">{{ $t('delivery.fields.destinationAddress') }}</div>
                <div class="font-weight-bold">{{ address?.destination?.address || '-' }}</div>
              </div>
              <div class="align-self-start">
                <McButton variant="secondary" :text="destinationBtnState === BUTTON_TYPE_SAVE ? $t('global.save') : $t('delivery.provider.changePinpoint')" @click="destinationBtnClick" :disabled="destinationBtnDisabled" />
              </div>
            </div>
            <b-card body-class="pb-0 pe-0">
              <AddressGmap identifier="destinationAddress" :location.sync="destination" :searchInputDisabled="destinationInputDisabled" />
            </b-card>
          </b-col>
        </b-row>
      </template>
      <template #button-action>
        <template>
          <McButton
            @click="modalWarning = false"
            variant="secondary" 
            class="me-2"
            :text="$t('global.cancel')"
          />
          <McButton
            @click="confirmBtnClick"
            variant="primary" 
            class="me-2"
            :text="$t('global.alert.text.confirm')"
            :disabled="disableConfirmBtn"
          />
        </template>
      </template>
    </ModalNotification>
  </div>
</template>
<script>
import ModalNotification from './ModalNotification'
import McButton from '@/components/McButton'
import AddressGmap from './AddressGmap'

export default {
  components: {
    ModalNotification,
    McButton,
    AddressGmap
  },
  props: {
    value: {
      type: Boolean,
      require: true
    },
    address: {
      type: Object,
      require: true
    },
    storing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      BUTTON_TYPE_SAVE: 'save',
      BUTTON_TYPE_CHANGE_PINPOINT: 'change-pinpoint',
      title: this.$t('delivery.provider.fillAddress'),
      msg: this.$t('delivery.provider.pinpointOriginAndDestination'),
      originBtnState: 'change-pinpoint',
      destinationBtnState: 'change-pinpoint',
      origin: null,
      destination: null,
    }
  },
  computed: {
    modalWarning: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('update:value', newVal)
      }
    },
    fullAddress() {
      return {
        origin: this.origin,
        destination: this.destination
      }
    },
    originBtnDisabled() {
      return this.originBtnState === this.BUTTON_TYPE_SAVE && this.origin === null
    },
    destinationBtnDisabled() {
      return this.destinationBtnState === this.BUTTON_TYPE_SAVE && this.destination === null
    },
    originInputDisabled() {
      return (this.originBtnState === this.BUTTON_TYPE_CHANGE_PINPOINT)
    },
    destinationInputDisabled() {
      return (this.destinationBtnState === this.BUTTON_TYPE_CHANGE_PINPOINT)
    },
    disableConfirmBtn() {
      return this.storing || this.origin === null || this.destination === null
    }
  },
  watch: {
    address: {
      handler: function (newAddress) {
        this.origin = newAddress.origin.geocode
        this.destination = newAddress.destination.geocode

        this.originBtnState = !newAddress.origin.geocode ? this.BUTTON_TYPE_SAVE : this.BUTTON_TYPE_CHANGE_PINPOINT
        this.destinationBtnState = !newAddress.destination.geocode ? this.BUTTON_TYPE_SAVE : this.BUTTON_TYPE_CHANGE_PINPOINT
      }
    }
  },
  methods: {
    originBtnClick() {
      this.originBtnState = this.originBtnState === this.BUTTON_TYPE_CHANGE_PINPOINT ? this.BUTTON_TYPE_SAVE : this.BUTTON_TYPE_CHANGE_PINPOINT
    },
    destinationBtnClick() {
      this.destinationBtnState = this.destinationBtnState === this.BUTTON_TYPE_CHANGE_PINPOINT ? this.BUTTON_TYPE_SAVE : this.BUTTON_TYPE_CHANGE_PINPOINT
    },
    confirmBtnClick() {
      // If user change their pinpoint, include pinpoint data to the request.
      this.$emit('handleConfirm', {
        origin: this.origin !== this.address.origin.geocode ? this.origin : undefined,
        destination: this.destination !== this.address.destination.geocode ? this.destination : undefined,
      })
    },
  },
}
</script>
<style lang="scss">
.mc-modal-warning {
  .__address-label {
    color: $mep-color-text-300;
  }
  .left-side {
    border-right: 1px solid $mep-color-text-100;
  }
  .right-side {
    border-left: 1px solid $mep-color-text-100;
    .__address {
      margin-left: 20px;
    }
  }
}
.pac-container {
  z-index: 2000 !important;
}
</style>